import { selectIsIOSFirebaseUIFeatureFlagOn } from 'core/userContext';
import {
  INTEGRATION_FORM_CONTENT,
  INTEGRATION_FORM_IOS_OPTIONS,
  P8_LEARN_MORE_URL,
} from 'modules/mobileApps/constants';
import {
  IntegrationFormField,
  useIntegrationFormContext,
} from 'modules/mobileApps/context/integrationForm';
import { IntegrationAuthType } from 'modules/mobileApps/types';
import { useSelector } from 'react-redux';
import { textColors } from 'ui/theme';
import { StyledPositiveBadge } from '../../AppDetails/IntegrationTable/IntegrationTable.styled';
import {
  Description,
  GroupLabel,
  Label,
  LearnMoreLink,
  LinkContent,
  Name,
  OptionButton,
  OptionContent,
  StyledOpenWindowIcon,
} from '../ApnsIntegrationForm.styled';

type Props = { handleContinue: () => void };

export const AuthSelect = ({ handleContinue }: Props) => {
  const isIOSFirebaseEnabled = useSelector(selectIsIOSFirebaseUIFeatureFlagOn);

  const { setValue, watch } = useIntegrationFormContext();
  const authType = watch(IntegrationFormField.authType);

  const integrationOptions = INTEGRATION_FORM_IOS_OPTIONS.filter(
    (option) => isIOSFirebaseEnabled || option.id !== IntegrationAuthType.FIREBASE_JSON,
  );

  const onClickOption = (optionValue: IntegrationAuthType) => {
    if (optionValue === authType) handleContinue();
    setValue(IntegrationFormField.authType, optionValue);
  };

  return (
    <>
      <GroupLabel data-test="auth-select-group-label">
        {INTEGRATION_FORM_CONTENT.groupLabel}
      </GroupLabel>
      {integrationOptions.map((option) => (
        <OptionButton
          data-test={`radio-${option.id}`}
          isSelected={authType === option.value}
          key={option.id}
          onClick={() => onClickOption(option.value)}
        >
          <OptionContent>
            <Name>
              <Label htmlFor={option.id}>{option.name}</Label>
              {option.id === IntegrationAuthType.P8 && (
                <StyledPositiveBadge>Recommended</StyledPositiveBadge>
              )}
            </Name>
            <Description>
              {option.description}
              {option.id === IntegrationAuthType.P8 && (
                <LearnMoreLink href={P8_LEARN_MORE_URL} target="_blank">
                  <LinkContent color={textColors.textSecondary} isUnderlined>
                    Learn more
                  </LinkContent>
                  <LinkContent>
                    <StyledOpenWindowIcon color={textColors.textSecondary} />
                  </LinkContent>
                </LearnMoreLink>
              )}
            </Description>
          </OptionContent>
        </OptionButton>
      ))}
    </>
  );
};
